/**
 * Priority levels for deferred work execution
 */
export enum DeferPriority {
  HIGH = 'high', // Execute as soon as possible during idle time
  NORMAL = 'normal', // Execute during normal idle periods
  LOW = 'low', // Execute only when browser is very idle
}
